import React, { useState, useEffect, useContext, useRef } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useFormik } from "formik";
import { axiosInstance } from "../../axiosInstance";
import successImg from "../../assets/images/successImg.png";
import "./OnBoardProfile.css";
import { object, string } from "yup";
import { ToastContainer, toast } from "react-toastify";
import { FaWhatsapp } from "react-icons/fa";
import * as Yup from "yup";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import Preloader from "../../Components/Loader/Loader";
import { BsArrowLeft } from "react-icons/bs";
import { axiosInstance_user } from "../../axiosInstance_user";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper", //box color
  border: "1px solid white", //box border
  boxShadow: 24,
  pt: 2,
  px: 0,
  pb: 3,
};
const SUPPORTED_FORMATS = ["image/jpeg", "image/png", "application/jpg"];
const ValidateSchema = object({
  name: string().required("this feild is required"),
  gender: string().required("this feild is required"),
  dob: string().required("this feild is required"),
  pob: string()
    .matches(/^[A-Za-z\s]+$/, "Only letters are allowed")
    .required("this feild is required"),
  tob: string().required("this feild is required"),
  height: string().required("this feild is required"),
  religion: string().required("this feild is required"),
  mother_tongue: string().required("this feild is required"),
  caste: string().required("this feild is required"),

  // profile: Yup.mixed()
  //   .test("fileCount", "You can only upload up to 5 images", (value) => {
  //     return value && value.length <= 5;
  //   })
  profile: Yup.mixed()
    .test("fileCount", "You can only upload up to 3 images", (value) => {
      return value && value.length <= 3;
    })

    // .test("fileFormat", "Only JPG/PNG/JPEG allowed", (value) =>
    //   value ? SUPPORTED_FORMATS.includes(value.type) : false
    // ),
    .test("fileFormat", "Only JPG/PNG/JPEG allowed", (value) => {
      if (!value || value.length === 0) return false;
      return value.every((file) => SUPPORTED_FORMATS.includes(file.type));
    }),

  total_brothers: string().required("this feild is required"),
  total_sisters: string().required("this feild is required"),
  married_brothers: string().required("this feild is required"),
  married_sisters: string().required("this feild is required"),

  contact_number: string()
    .matches(/^\d{10}$/, "Contact Number must be 10 digits")
    .required("this feild is required"),
  state: string().required("this feild is required"),
  city: string().required("this feild is required"),
  address: string().required("this feild is required"),
  is_accepted: Yup.bool().oneOf([true], "this feild is required"),
});
export function OnBoardProfile() {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [selectedProfileFile, setSelectedProfileFile] = useState([]);
  const [profileImgPreview, setProfileImgPreview] = useState([]);
  const [agencyName, setAgencyName] = useState([]);
  const [stateId, setStateId] = useState();
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [loading, setLoading] = useState(false);

  const [religion, setReligion] = useState([]);
  const [religionId, setReligionId] = useState();
  const [casteId, setCasteId] = useState();
  const [caste, setCaste] = useState([]);
  const [subcaste, setSubCaste] = useState([]);
  const [motherTongue, setMotherTongue] = useState([]);
  const { publicToken, name, agencyNameUser } = useParams();
  console.log("params", publicToken);

  const fileInputRef = useRef(null);

  //  for disable right click
  // useEffect(() => {
  //   const handleRightClick = (e) => {
  //     e.preventDefault();
  //   };
  //   document.addEventListener("contextmenu", handleRightClick);
  //   return () => {
  //     document.removeEventListener("contextmenu", handleRightClick);
  //   };
  // }, []);

  const formik = useFormik({
    initialValues: {
      profile: [],
      public_token: publicToken,
      name: "",
      gender: "",
      dob: "",
      tob: "",
      pob: "",
      rashi: "",
      nakshatra: "",
      height: "",
      marital_status: "",
      religion: "",
      mother_tongue: "",
      caste: "",
      sub_caste: "",
      gotra: "",
      manglik: "",
      education: "",
      college_name: "",
      employed_in: "",
      organization_name: "",
      annual_income: "",

      father_name: "",
      father_occupation: "",
      mother_name: "",
      mother_occupation: "",
      total_brothers: "",
      total_sisters: "",
      married_brothers: "",
      married_sisters: "",

      contact_number: "",
      state: "",
      city: "",
      address: "",
      is_accepted: false,
      is_blur: true,
      is_public: true,
      is_web: true,
    },
    validationSchema: ValidateSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        // getting id on user select so converting id into name
        setLoading(true);
        const selectedReligion = religion.find(
          (r) => r.id === Number(values.religion),
        );
        const selectedCaste = caste.find((c) => c.id === Number(values.caste));
        const selectedSubCaste = subcaste.find(
          (s) => s.id === Number(values.sub_caste),
        );
        const selectedMotherTongue = motherTongue.find(
          (m) => m.id === Number(values.mother_tongue),
        );

        const contact_number = Number(values.contact_number) || 0;

        const selectedState = state.find((s) => s.id === Number(values.state));
        const selectedCity = city.find((c) => c.id === Number(values.city));
        const formData = new FormData();

        // personal data

        formData.append("public_token", values.public_token);
        formData.append("name", values.name);
        formData.append("gender", values.gender);
        formData.append("dob", values.dob);
        formData.append("tob", values.tob);
        formData.append("pob", values.pob);
        formData.append("rashi", values.rashi);
        formData.append("nakshatra", values.nakshatra);
        formData.append("height", values.height);
        formData.append("marital_status", values.marital_status);
        formData.append("religion", selectedReligion?.name || "");
        formData.append("mother_tongue", selectedMotherTongue?.name || "");
        formData.append("caste", selectedCaste?.name || "");
        formData.append("sub_caste", selectedSubCaste?.name || "");
        formData.append("gotra", values.gotra);
        formData.append("manglik", values.manglik);
        formData.append("education", values.education);
        formData.append("college_name", values.college_name);
        formData.append("employed_in", values.employed_in);
        formData.append("organization_name", values.organization_name);
        formData.append("annual_income", values.annual_income);

        // Family Details
        formData.append("father_name", values.father_name);
        formData.append("father_occupation", values.father_occupation);
        formData.append("mother_name", values.mother_name);
        formData.append("mother_occupation", values.mother_occupation);
        formData.append("total_brothers", values.total_brothers);
        formData.append("married_brothers", values.married_brothers);
        formData.append("total_sisters", values.total_sisters);
        formData.append("married_sisters", values.married_sisters);

        // Contact
        formData.append("contact_number", contact_number);
        formData.append("state", selectedState?.name || "");
        formData.append("city", selectedCity?.name || "");
        formData.append("address", values.address);

        // Acceptance
        formData.append("is_accepted", values.is_accepted ? "true" : "false");
        formData.append("is_blur", values.is_blur ? "true" : "false");
        formData.append("is_public", values.is_public ? "true" : "false");
        formData.append("is_web", values.is_web ? "true" : "false");

        // Append file only if selected
        if (selectedProfileFile && selectedProfileFile.length > 0) {
          selectedProfileFile.map((file) => {
            formData.append("profile", file);
          });
        }

        const response = await axiosInstance.post("create-biodata", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (response.data.status === true) {
          toast.success(response.data.message || "Updated Successfully!");
          setSelectedProfileFile(null);
          setProfileImgPreview([]);
          formik.setFieldValue("profile", []);
          if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }
          handleOpen();
          resetForm();
          setTimeout(() => {
            handleClose();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }, 100);
          setLoading(false);
        } else {
          toast.error("Something went wrong, please try again!");
          setLoading(false);
        }
      } catch (error) {
        console.error("Submission failed:", error);
        toast.error("Submission failed! Please try again.");
        setLoading(false);
      } finally {
        setLoading(false);
      }
    },
  });
  async function handlePublicProfile() {
    const public_token = localStorage.getItem("public_token");
    try {
      const response = await axiosInstance.get(
        `share-biodata-list/${public_token}`,
      );
      setAgencyName(response.data.data.agency_name || "nathicharami-agent");
      console.log("an", response.data.data.agency_name);
    } catch (error) {
      console.log("Error while fetching profiles", error);
    }
  }

  useEffect(() => {
    handlePublicProfile();
  }, []);

  function shareWhatsapp() {
    const currentUrl = window.location.href;
    const shareText = `Greetings from ${agencyName}\n\nPlease complete your biodata to help us find your ideal match. Click the link below:\n${currentUrl}\n\nYour information is safe and used only for matchmaking purposes.`;

    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(shareText)}`;

    window.open(whatsappUrl, "_blank");
  }
  async function LoadState() {
    try {
      const response = await axiosInstance_user.get("/dropdown/states");
      const data = response.data;
      console.log("State", response.data);
      setState(data);
    } catch (error) {
      console.log("Error white fetching");
      toast.error("Error white fetching", error);
    }
  }
  async function LoadCity(stateId) {
    try {
      const response = await axiosInstance_user.get(
        `/dropdown/cities/${stateId}`,
      );
      const data = response.data;
      console.log("State", response.data);
      setCity(data);
    } catch (error) {
      console.log("Error white fetching");
      toast.error("Error white fetching", error);
    }
  }
  useEffect(() => {
    if (stateId) {
      LoadCity(stateId);
    }
  }, [stateId]);

  useEffect(() => {
    LoadState();
  }, []);
  const token = localStorage.getItem("token");
  async function LoadReligion() {
    try {
      const response = await axiosInstance_user.get("/dropdown/choices");

      if (response.status === 200 && response.data) {
        console.log("religion", response.data.religion);
        setReligion(response.data.religion);
        setMotherTongue(response.data.mother_tongue);
      } else {
        console.error("Unexpected response format or status", response);
      }
    } catch (error) {
      console.error("Failed to load religion data:", error.message);
    }
  }

  async function LoadCaste(religionId) {
    const response = await axiosInstance_user.get(
      `/dropdown/caste/${religionId}`,
    );
    const data = response.data;
    console.log("caste", data);
    setCaste(data);
  }
  useEffect(() => {
    LoadReligion();
  }, []);

  useEffect(() => {
    if (religionId) {
      LoadCaste(religionId);
    }
  }, [religionId]);

  async function LoadSubCaste(casteId) {
    const response = await axiosInstance_user.get(
      `/dropdown/sub-caste/${casteId}`,
    );
    const data = response.data;
    console.log("subcaste", data);
    setSubCaste(data);
  }
  useEffect(() => {
    if (casteId) {
      LoadSubCaste(casteId);
    }
  }, [casteId]);

  return (
    <>
      {loading && <Preloader />}
      <div className="container">
        <div>
          {token ? (
            // <Link to="/home" className="leftArrow">
            //   <span>
            //     <BsArrowLeft /> {agencyName}
            //   </span>
            // </Link>
            <div className="back-link-wrapper">
              <Link to="/home" className="back-link">
                <BsArrowLeft className="back-arrow-icon" />
                {/* <span>{agencyNameUser}</span> */}
                <span>
                  {agencyNameUser === "null" ||
                  agencyNameUser === null ||
                  agencyNameUser === ""
                    ? "Nathicharami-Agency"
                    : agencyNameUser}
                </span>
              </Link>
            </div>
          ) : (
            <div className="back-link-wrapper">
              <div className="back-link">
                <span>{agencyNameUser}</span>
              </div>
            </div>
          )}
          <div className="text-bio">Bio Data</div>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div className="text-category">Personal Details :</div>
          <div>
            {token ? (
              <button className="btnWhatsapp" onClick={shareWhatsapp}>
                <span>
                  <FaWhatsapp />
                </span>
              </button>
            ) : (
              ""
            )}
          </div>
        </div>
        <form onSubmit={formik.handleSubmit}>
          <div className="basicMainContainer">
            <div>
              {/* row -1 */}
              {/* <div className="basicSubcontainer">
                <div>
                  <div className="lableName">Upload Bio Data</div>
                  <div className="basicTextbox">
                    <input
                      type="file"
                      style={{ padding: "7px" }}
                      // onChange={(e) => {
                      //   const file = e.target.files[0];
                      //   if (file) {

                      //     setSelectedDocumentFile(file);
                      //   }
                      // }}
                    ></input>
                    <div className="maxText">
                      Please upload your bio-data file, and we’ll automatically
                      fill out the form for you.
                    </div>
                  </div>
                </div>
              </div> */}
              {/* row 0 */}
              <div className="basicSubcontainer">
                <div>
                  <div className="lableName">Upload Photo:</div>
                  <div className="basicTextbox">
                    <input
                      ref={fileInputRef}
                      type="file"
                      style={{ padding: "7px" }}
                      multiple
                      accept="image/jpeg,image/jpg,image/png"
                      onChange={(e) => {
                        const files = Array.from(e.target.files);
                        if (files.length > 0) {
                          const imageUrls = files.map((file) =>
                            URL.createObjectURL(file),
                          );
                          setProfileImgPreview(imageUrls);
                          setSelectedProfileFile(files);
                          formik.setFieldValue("profile", files);
                        } else {
                          formik.setFieldValue("profile", null);
                        }
                      }}
                      className={
                        formik.touched.profile && formik.errors.profile
                          ? "error"
                          : ""
                      }
                    ></input>{" "}
                    {/* <div className="maxText">Max size 5 MB per image</div> */}
                    <div>
                      {formik.touched.profile && formik.errors.profile && (
                        <div className="text-danger">
                          {formik.errors.profile}
                        </div>
                      )}
                    </div>
                    <div>Can add upto 3 images</div>
                    <div className="image-preview-container">
                      {profileImgPreview.map((src, index) => (
                        <div className="image-preview-wrapper" key={index}>
                          <img
                            key={index}
                            src={src}
                            alt={`Preview ${index}`}
                            className="image-preview"
                          />
                          <button
                            type="button"
                            className="image-remove-btn"
                            onClick={() => {
                              const updatedPreviews = profileImgPreview.filter(
                                (_, i) => i !== index,
                              );

                              const updatedFiles = selectedProfileFile.filter(
                                (_, i) => i !== index,
                              );

                              setProfileImgPreview(updatedPreviews);
                              setSelectedProfileFile(updatedFiles);

                              formik.setFieldValue(
                                "profile",
                                updatedFiles.length > 0 ? updatedFiles : null,
                              );

                              if (fileInputRef.current) {
                                fileInputRef.current.value = "";
                              }
                            }}
                          >
                            ×
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                {/* <div
                  className="form-check form-switch d-flex align-items-center"
                  style={{ marginLeft: "-35px" }}
                >
                  <label
                    className="form-check-label lableName"
                    htmlFor="blurSwitch"
                  >
                    Blur Image in Website:
                  </label>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="blurSwitch"
                    style={{
                      marginTop: "10px",
                      fontSize: "25px",
                      marginLeft: "20px",
                    }}
                  />
                </div> */}
              </div>
              {/* row1 */}
              <div className="basicSubcontainer">
                <div>
                  <div className="lableName">
                    Full Name<span className="text-danger">*</span>
                  </div>
                  <div className="basicTextbox">
                    <input
                      type="text"
                      id="name"
                      name="name"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.name}
                      placeholder="Enter Full Name"
                      className={
                        formik.touched.name && formik.errors.name ? "error" : ""
                      }
                    ></input>
                    <div>
                      {formik.touched.name && formik.errors.name && (
                        <div className="text-danger">{formik.errors.name}</div>
                      )}
                    </div>
                  </div>
                </div>
                <div>
                  <div className="lableName">
                    Gender <span className="text-danger">*</span>
                  </div>
                  {/* <div className="basicRadio">
                  <input type="radio" name="gender" checked={user?.gender === 1} />
                  <span>Male</span>
                  <input type="radio" name="gender" checked={user?.gender === 2} />
                  <span>Female</span>
                </div> */}
                  <div>
                    <select
                      name="gender"
                      id="gender"
                      value={formik.values.gender}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className={`dropdown-btnBasic ${
                        formik.touched.gender && formik.errors.gender
                          ? "error"
                          : ""
                      }`}
                    >
                      <option value="" disabled>
                        Select Gender
                      </option>
                      <option>Male</option>
                      <option>Female</option>
                    </select>
                    <div>
                      {formik.touched.gender && formik.errors.gender && (
                        <div className="text-danger">
                          {formik.errors.gender}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* row2 */}
              <div className="basicSubcontainer">
                <div>
                  <div className="lableName">
                    Date of Birth <span className="text-danger">*</span>
                  </div>
                  <div className="basicTextbox">
                    <input
                      type="date"
                      id="dob"
                      name="dob"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.dob}
                      max={new Date().toISOString().split("T")[0]}
                      className={
                        formik.touched.dob && formik.errors.dob ? "error" : ""
                      }
                    ></input>
                    <div>
                      {formik.touched.dob && formik.errors.dob && (
                        <div className="text-danger">{formik.errors.dob}</div>
                      )}
                    </div>
                  </div>
                </div>
                <div>
                  <div className="lableName">
                    Time of Birth<span className="text-danger">*</span>
                  </div>
                  <div className="basicTextbox">
                    <input
                      type="time"
                      step="1" // enables seconds
                      id="tob"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.tob}
                      placeholder="Enter Time Of Birth"
                      className={
                        formik.touched.tob && formik.errors.tob ? "error" : ""
                      }
                    ></input>
                    <div>
                      {formik.touched.tob && formik.errors.tob && (
                        <div className="text-danger">{formik.errors.tob}</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* row3 */}
              <div className="basicSubcontainer">
                <div>
                  <div className="lableName">
                    Place of Birth <span className="text-danger">*</span>
                  </div>
                  <div className="basicTextbox">
                    <input
                      type="text"
                      id="pob"
                      name="pob"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.pob}
                      placeholder="Enter Place Of Birth"
                      className={
                        formik.touched.pob && formik.errors.pob ? "error" : ""
                      }
                    ></input>
                    <div>
                      {formik.touched.pob && formik.errors.pob && (
                        <div className="text-danger">{formik.errors.pob}</div>
                      )}
                    </div>
                  </div>
                </div>
                <div>
                  <div className="lableName">Rashi</div>
                  <div>
                    {/* <select className="dropdown-btnBasic">
                  
                    <option>Select</option>
                    <option>---</option>
                  </select> */}
                    <div className="basicTextbox">
                      <select
                        name="rashi"
                        id="rashi"
                        value={formik.values.rashi}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className={`dropdown-btnBasic ${
                          formik.touched.rashi && formik.errors.rashi
                            ? "error"
                            : ""
                        }`}
                      >
                        <option value="" disabled>
                          Select Rashi
                        </option>
                        <option>Mesham</option>
                        <option>Vrushabham</option>
                        <option>Midhunam</option>
                        <option>Karkatakam</option>
                        <option>Simham</option>
                        <option>Kanya</option>
                        <option>Tula</option>
                        <option>Vruschikam</option>
                        <option>Dhanussu</option>
                        <option>Makaram</option>
                        <option>Kumbham</option>
                        <option>Meenam</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              {/* row4 */}
              <div className="basicSubcontainer">
                <div>
                  <div className="lableName">Nakshatra</div>
                  <div>
                    {/* <select className="dropdown-btnBasic">
                   
                    <option>---</option>
                    <option>--</option>
                  </select> */}
                    <div className="basicTextbox">
                      <select
                        name="nakshatra"
                        id="nakshatra"
                        value={formik.values.nakshatra}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className={`dropdown-btnBasic ${
                          formik.touched.nakshatra && formik.errors.nakshatra
                            ? "error"
                            : ""
                        }`}
                      >
                        <option value="" disabled>
                          Select Nakshatra
                        </option>
                        <option>Anuraadha</option>
                        <option>Arudra</option>
                        <option>Ashlesha</option>
                        <option>Ashwini</option>
                        <option>Bharani</option>
                        <option>Chittaa</option>
                        <option>Dhanishta</option>
                        <option>Asthami</option>
                        <option>Jyesthaa</option>
                        <option> Kritika</option>
                        <option> Maghaa</option>
                        <option>Mula</option>
                        <option> Mrigasiraa</option>
                        <option>Punarvasu</option>
                        <option>Poorvashaadha</option>
                        <option> Poorvabhadraa</option>
                        <option>Pubba</option>
                        <option>Pushya</option>
                        <option> Revati</option>
                        <option>Rohini</option>
                        <option>Shatabhisha</option>
                        <option>Shravana</option>
                        <option>Swaati</option>
                        <option>Uttarashaadha</option>
                        <option> Uttaraa bhadra</option>
                        <option>Uttara</option>
                        <option>Vishaakha</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="lableName">
                    Height<span className="text-danger">*</span>
                  </div>
                  <div>
                    {/* <select className="dropdown-btnBasic">
                  
                    <option>Select</option>
                    <option>--</option>
                  </select> */}
                    <div className="basicTextbox">
                      {/* <input
                      type="text"
                      id="height"
                      name="height"
                      onChange={formik.handleChange}
                      value={formik.values.height}
                      placeholder="Enter Height"
                    ></input> */}
                      <select
                        name="height"
                        id="height"
                        value={formik.values.height}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className={`dropdown-btnBasic ${
                          formik.touched.height && formik.errors.height
                            ? "error"
                            : ""
                        }`}
                      >
                        <option value="" disabled>
                          Select Height
                        </option>
                        <option value="4.0">4.0</option>
                        <option value="4.1">4.1</option>
                        <option value="4.2">4.2</option>
                        <option value="4.3">4.3</option>
                        <option value="4.4">4.4 </option>
                        <option value="4.5">4.5 </option>
                        <option value="4.6">4.6</option>
                        <option value="4.7">4.7 </option>
                        <option value="4.8">4.8 </option>
                        <option value="4.9">4.9 </option>
                        <option value="4.10">4.10</option>
                        <option value="4.11">4.11</option>
                        <option value="5.0">5.0 </option>
                        <option value="5.1">5.1 </option>
                        <option value="5.2">5.2 </option>
                        <option value="5.3">5.3 </option>
                        <option value="5.4">5.4 </option>
                        <option value="5.5">5.5 </option>
                        <option value="5.6">5.6 </option>
                        <option value="5.7">5.7 </option>
                        <option value="5.8">5.8 </option>
                        <option value="5.9">5.9 </option>
                        <option value="5.10">5.10 </option>
                        <option value="5.11">5.11 </option>
                        <option value="6.0">6.0 </option>
                        <option value="6.1">6.1 </option>
                        <option value="6.2">6.2 </option>
                        <option value="6.3">6.3 </option>
                        <option value="6.4">6.4 </option>
                        <option value="6.5">6.5 </option>
                        <option value="6.6">6.6 </option>
                        <option value="6.7">6.7 </option>
                        <option value="6.8">6.8 </option>
                        <option value="6.9">6.9 </option>
                        <option value="6.10">6.10</option>
                        <option value="6.11">6.11</option>
                        <option value="7.0">7.0 </option>
                        <option value="7.1">7.1 </option>
                        <option value="7.2">7.2 </option>
                        <option value="7.3">7.3 </option>
                        <option value="7.4">7.4 </option>
                        <option value="7.5">7.5 </option>
                        <option value="7.6">7.6 </option>
                        <option value="7.7">7.7 </option>
                        <option value="7.8">7.8 </option>
                        <option value="7.9">7.9 </option>
                        <option value="7.10">7.10 </option>
                        <option value="7.11">7.11 </option>
                      </select>
                      <div>
                        {formik.touched.height && formik.errors.height && (
                          <div className="text-danger">
                            {formik.errors.height}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* row5 */}
              <div className="basicSubcontainer">
                <div>
                  <div className="lableName">Marital Status</div>
                  <div>
                    {/* <select className="dropdown-btnBasic">
                  
                    <option>Select</option>
                    <option>---</option>
                  </select> */}
                    <div className="basicTextbox">
                      <input
                        type="text"
                        id="marital_status"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.marital_status}
                        placeholder="Enter Marital Status"
                        className={
                          formik.touched.marital_status &&
                          formik.errors.marital_status
                            ? "error"
                            : ""
                        }
                      ></input>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="lableName">
                    Religion<span className="text-danger">*</span>
                  </div>
                  <div>
                    {/* <select className="dropdown-btnBasic">
                  
                    <option>Select</option>
                    <option>---</option>
                  </select> */}
                    <div className="basicTextbox">
                      <select
                        name="religion"
                        id="religion"
                        value={formik.values.religion}
                        onChange={(e) => {
                          const selectedId = e.target.value;
                          formik.setFieldValue("religion", selectedId);
                          setReligionId(selectedId);
                          console.log("Selected Religion ID:", selectedId);
                        }}
                        onBlur={formik.handleBlur}
                        className={`dropdown-btnBasic ${
                          formik.touched.religion && formik.errors.religion
                            ? "error"
                            : ""
                        }`}
                      >
                        <option value="" disabled>
                          Select Religion
                        </option>
                        {religion.map((list) => (
                          <option value={list.id} key={list.id}>
                            {list.name}
                          </option>
                        ))}
                      </select>
                      <div>
                        {formik.touched.religion && formik.errors.religion && (
                          <div className="text-danger">
                            {formik.errors.religion}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* row6 */}
              <div className="basicSubcontainer">
                <div>
                  <div className="lableName">
                    Mother Tongue <span className="text-danger">*</span>
                  </div>
                  <div>
                    {/* <select className="dropdown-btnBasic">
                    <option>Select</option>
                    <option>type 1</option>
                    <option>type 2</option>
                  </select> */}
                    <div className="basicTextbox">
                      {/* <input
                      type="text"
                      id="mother_tongue"
                      name="mother_tongue"
                      onChange={formik.handleChange}
                      value={formik.values.mother_tongue}
                      placeholder="Enter Mother Tongue"
                    ></input> */}
                      <select
                        name="mother_tongue"
                        id="mother_tongue"
                        value={formik.values.mother_tongue}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className={`dropdown-btnBasic ${
                          formik.touched.mother_tongue &&
                          formik.errors.mother_tongue
                            ? "error"
                            : ""
                        }`}
                      >
                        <option value="">Select Mother Tongue</option>
                        {motherTongue.map((list) => (
                          <option value={list.id} key={list.id}>
                            {list.name}
                          </option>
                        ))}
                      </select>
                      <div>
                        {formik.touched.mother_tongue &&
                          formik.errors.mother_tongue && (
                            <div className="text-danger">
                              {formik.errors.mother_tongue}
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="lableName">
                    Caste <span className="text-danger">*</span>
                  </div>
                  <div>
                    {/* <select className="dropdown-btnBasic">
                   
                    <option>Select</option>
                    <option>type 2</option>
                  </select> */}
                    <div className="basicTextbox">
                      <select
                        name="caste"
                        id="caste"
                        value={formik.values.caste}
                        onChange={(e) => {
                          const selectedId = e.target.value;
                          formik.setFieldValue("caste", selectedId);
                          setCasteId(selectedId);
                          console.log("Selected Caste ID:", selectedId);
                        }}
                        onBlur={formik.handleBlur}
                        className={`dropdown-btnBasic ${
                          formik.touched.caste && formik.errors.caste
                            ? "error"
                            : ""
                        }`}
                      >
                        <option value="">Select Caste</option>
                        {caste.map((list) => (
                          <option value={list.id} key={list.id}>
                            {list.name}
                          </option>
                        ))}
                      </select>
                      <div>First Select Religion</div>
                      <div>
                        {formik.touched.caste && formik.errors.caste && (
                          <div className="text-danger">
                            {formik.errors.caste}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* row7 */}
              <div className="basicSubcontainer">
                <div>
                  <div className="lableName">Sub Caste</div>
                  <div className="basicTextbox">
                    <select
                      name="sub_caste"
                      id="sub_caste"
                      value={formik.values.sub_caste}
                      // onChange={(e) => {
                      //   const selectedId = e.target.value;
                      //   formik.setFieldValue("caste", selectedId);
                      //   setCasteId(selectedId);
                      //   console.log("Selected SubCaste ID:", selectedId);
                      // }}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className={`dropdown-btnBasic ${
                        formik.touched.caste && formik.errors.caste
                          ? "error"
                          : ""
                      }`}
                    >
                      <option value="">Select Sub Caste</option>
                      {subcaste.map((list) => (
                        <option value={list.id} key={list.id}>
                          {list.name}
                        </option>
                      ))}
                    </select>
                    <div>First Select Caste</div>
                  </div>
                </div>
                <div>
                  <div className="lableName">Gothram</div>
                  <div className="basicTextbox">
                    <input
                      type="text"
                      placeholder="Enter Gothram"
                      id="gotra"
                      onChange={formik.handleChange}
                      value={formik.values.gotra}
                    ></input>
                  </div>
                </div>
              </div>

              {/* row8 */}
              <div className="basicSubcontainer">
                <div>
                  <div className="lableName">Manglik</div>
                  <div>
                    {/* <select className="dropdown-btnBasic">
                   
                    <option>Select</option>
                    <option>type 1</option>
                  </select> */}
                    <div className="basicTextbox">
                      <input
                        type="text"
                        id="manglik"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.manglik}
                        placeholder="Enter Manglik"
                      ></input>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="lableName">Education</div>
                  <div>
                    {/* <select className="dropdown-btnBasic">
                  
                    <option>Select</option>
                    <option>type 1</option>
                  </select> */}
                    <div className="basicTextbox">
                      <input
                        type="text"
                        id="education"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.education}
                        placeholder="Enter Education"
                      ></input>
                    </div>
                  </div>
                </div>
              </div>
              {/* row9 */}
              <div className="basicSubcontainer">
                <div>
                  <div className="lableName">College Name</div>
                  <div className="basicTextbox">
                    <input
                      type="text"
                      placeholder="Enter College Name"
                      id="college_name"
                      value={formik.values.college_name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    ></input>
                  </div>
                </div>
                <div>
                  <div className="lableName">Employee Designation</div>
                  <div>
                    {/* <select className="dropdown-btnBasic">
                  
                    <option>Select</option>
                    <option>type 1</option>
                  </select> */}
                    <div className="basicTextbox">
                      <input
                        type="text"
                        id="employed_in"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.employed_in}
                        placeholder="Enter Employee Designation"
                      ></input>
                    </div>
                  </div>
                </div>
              </div>
              {/* row10 */}
              <div className="basicSubcontainer">
                <div>
                  <div className="lableName">Organization Name</div>
                  <div className="basicTextbox">
                    <input
                      type="text"
                      placeholder="Enter Organization name"
                      value={formik.values.organization_name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      id="organization_name"
                    ></input>
                  </div>
                </div>
                <div>
                  <div className="lableName">Annual Income</div>
                  <div>
                    {/* <select className="dropdown-btnBasic">
                   
                    <option>Select</option>
                    <option>type 1</option>
                  </select> */}
                    <div className="basicTextbox">
                      <input
                        type="text"
                        id="annual_income"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.annual_income}
                        placeholder="Enter Annual Income"
                      ></input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-category">Family Details :</div>
          <div className="familyContainer">
            {/* row1 */}
            <div className="family-subcontainer">
              <div>
                <div className="family-label">Father’s Name</div>
                <div className="family-input">
                  <input
                    type="text"
                    placeholder="Enter Father Name"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    id="father_name"
                  />
                </div>
              </div>
              <div>
                <div className="family-label">Father’s Occupation</div>
                {/* <div>
            <select className="dropdown-btnFamily">
              <option>Select </option>
            
              <option>type 1</option>
            </select>
          </div> */}
                <div className="family-input">
                  <input
                    type="text"
                    placeholder="Enter Father's Occupation"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    id="father_occupation"
                  />
                </div>
              </div>
            </div>
            {/* row2 */}
            <div className="family-subcontainer">
              <div>
                <div className="family-label">Mother’s Name</div>
                <div className="family-input">
                  <input
                    type="text"
                    placeholder="Enter Mother Name"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    id="mother_name"
                  />
                </div>
              </div>
              <div>
                <div className="family-label">Mother’s Occupation</div>
                {/* <div>
            <select className="dropdown-btnFamily">
              <option>Select </option>
            
              <option>type 1</option>
            </select>
          </div> */}
                <div className="family-input">
                  <input
                    type="text"
                    placeholder="Enter Mother's Occupation"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    id="mother_occupation"
                  />
                </div>
              </div>
            </div>
            {/* row3 */}
            <div className="family-subcontainer">
              <div>
                <div className="family-label">
                  No. of Brothers<span className="text-danger">*</span>
                </div>
                {/* <div>
            <select className="dropdown-btnFamily">
              <option>Select </option>
            
              <option>type 1</option>
            </select>
          </div> */}
                <div className="family-input">
                  <select
                    name="total_brothers"
                    id="total_brothers"
                    value={formik.values.total_brothers}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className={`dropdown-btnBasic ${
                      formik.touched.total_brothers &&
                      formik.errors.total_brothers
                        ? "error"
                        : ""
                    }`}
                  >
                    <option value="" disabled>
                      Select
                    </option>
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                  </select>
                  <div>
                    {formik.touched.total_brothers &&
                      formik.errors.total_brothers && (
                        <div className="text-danger">
                          {formik.errors.total_brothers}
                        </div>
                      )}
                  </div>
                </div>
              </div>
              <div>
                <div className="family-label">
                  No. of Sisters<span className="text-danger">*</span>
                </div>

                <div className="family-input">
                  <select
                    name="total_sisters"
                    id="total_sisters"
                    value={formik.values.total_sisters}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className={`dropdown-btnBasic ${
                      formik.touched.total_sisters &&
                      formik.errors.total_sisters
                        ? "error"
                        : ""
                    }`}
                  >
                    <option value="" disabled>
                      Select
                    </option>
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                  </select>
                  <div>
                    {formik.touched.total_sisters &&
                      formik.errors.total_sisters && (
                        <div className="text-danger">
                          {formik.errors.total_sisters}
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
            {/* row4 */}
            <div className="family-subcontainer">
              <div>
                <div className="family-label">
                  Married Brothers<span className="text-danger">*</span>
                </div>

                <div className="family-input">
                  <select
                    name="married_brothers"
                    id="married_brothers"
                    value={formik.values.married_brothers}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className={`dropdown-btnBasic ${
                      formik.touched.married_brothers &&
                      formik.errors.married_brothers
                        ? "error"
                        : ""
                    }`}
                  >
                    <option value="" disabled>
                      Select
                    </option>
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                  </select>
                  <div>
                    {formik.touched.married_brothers &&
                      formik.errors.married_brothers && (
                        <div className="text-danger">
                          {formik.errors.married_brothers}
                        </div>
                      )}
                  </div>
                </div>
              </div>
              <div>
                <div className="family-label">
                  Married Sisters<span className="text-danger">*</span>
                </div>

                <div className="family-input">
                  <select
                    name="married_sisters"
                    id="married_sisters"
                    value={formik.values.married_sisters}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className={`dropdown-btnBasic ${
                      formik.touched.married_sisters &&
                      formik.errors.married_sisters
                        ? "error"
                        : ""
                    }`}
                  >
                    <option value="" disabled>
                      Select
                    </option>
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                  </select>
                  <div>
                    {formik.touched.married_sisters &&
                      formik.errors.married_sisters && (
                        <div className="text-danger">
                          {formik.errors.married_sisters}
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-category">Contact Details : </div>
          <div className="contactContainer">
            {/* row1 */}
            <div className="contact-subcontainer">
              <div>
                <div className="contact-label">
                  Contact Number <span className="text-danger">*</span>
                </div>
                <div className="contact-input">
                  <input
                    type="text"
                    placeholder="Enter your number"
                    id="contact_number"
                    name="contact_number"
                    value={formik.values.contact_number}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className={
                      formik.touched.contact_number &&
                      formik.errors.contact_number
                        ? "error"
                        : ""
                    }
                  />
                  <div>
                    {formik.touched.contact_number &&
                      formik.errors.contact_number && (
                        <div className="text-danger">
                          {formik.errors.contact_number}
                        </div>
                      )}
                  </div>
                </div>
              </div>
              <div>
                <div className="contact-label">
                  State
                  {""} <span className="text-danger">*</span>
                </div>
                <div className="contact-input">
                  <select
                    name="state"
                    id="state"
                    value={formik.values.state}
                    onChange={(e) => {
                      const selectedId = e.target.value;
                      formik.setFieldValue("state", selectedId);
                      setStateId(selectedId);
                      console.log("Selected State ID:", selectedId);
                    }}
                    onBlur={formik.handleBlur}
                    className={`dropdown-btnBasic ${
                      formik.touched.state && formik.errors.state ? "error" : ""
                    }`}
                  >
                    <option value="" disabled>
                      Select State
                    </option>
                    {state?.map((list) => (
                      <option value={list.id} key={list.id}>
                        {list.name}
                      </option>
                    ))}
                  </select>
                  <div>
                    {formik.touched.state && formik.errors.state && (
                      <div className="text-danger">{formik.errors.state}</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* row2 */}
            <div className="contact-subcontainer">
              <div>
                <div className="contact-label">
                  City <span className="text-danger">*</span>
                </div>

                <div>
                  <select
                    name="city"
                    id="city"
                    value={formik.values.city}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className={`dropdown-btnBasic ${
                      formik.touched.city && formik.errors.city ? "error" : ""
                    }`}
                  >
                    <option value="" disabled>
                      Select City
                    </option>
                    {city?.map((list) => (
                      <option value={list.id} key={list.id}>
                        {list.name}
                      </option>
                    ))}
                  </select>
                  <div className="contact-label" style={{ marginTop: "0px" }}>
                    First select the state
                  </div>
                  {formik.touched.city && formik.errors.city && (
                    <div className="text-danger">{formik.errors.city}</div>
                  )}
                </div>
              </div>
              <div>
                <div className="contact-label">
                  Address <span className="text-danger">*</span>
                </div>
                <div className="contact-input">
                  <input
                    type="text"
                    placeholder="Enter address"
                    id="address"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.address}
                    className={
                      formik.touched.address && formik.errors.address
                        ? "error"
                        : ""
                    }
                  />
                  {formik.touched.address && formik.errors.address && (
                    <div className="text-danger">{formik.errors.address}</div>
                  )}
                </div>
              </div>
            </div>

            {/* row 3*/}
            <div className="contact-subcontainer mt-3">
              <div>
                <div className="checkboxLabel">
                  {" "}
                  1. I accept to share my uploaded images publicly for
                  matchmaking purposes.
                </div>
                <div
                  style={{ marginTop: "10px", marginBottom: "20px" }}
                  className="form-check form-switch "
                >
                  <input
                    type="checkbox"
                    id="is_public"
                    name="is_public"
                    className="form-check-input"
                    checked={formik.values.is_public}
                    onChange={formik.handleChange}
                  />
                  &nbsp;
                  <span
                    style={{
                      color: "#2B171B",
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                  >
                    {formik.values.is_public ? "Yes" : "No"}
                  </span>
                  {formik.errors.is_public && formik.touched.is_public && (
                    <div className="text-danger">{formik.errors.is_public}</div>
                  )}
                </div>
              </div>
            </div>
            {/* row 4 */}
            <div className="contact-subcontainer">
              <div>
                <div className="checkboxLabel">
                  {" "}
                  2. I accept to share my uploaded images on Nathicharami
                  platform
                </div>
                <div
                  style={{ marginTop: "10px", marginBottom: "20px" }}
                  className="form-check form-switch "
                >
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="is_web"
                    name="is_web"
                    checked={formik.values.is_web}
                    onChange={formik.handleChange}
                  />
                  <span
                    style={{
                      color: "#2B171B",
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                  >
                    {formik.values.is_web ? "Yes" : "No"}
                  </span>

                  {formik.errors.is_web && formik.touched.is_web && (
                    <div className="text-danger">{formik.errors.is_web}</div>
                  )}
                </div>
              </div>
            </div>
            {/* row 5 */}
            <div className="contact-subcontainer">
              <div>
                <div className="checkboxLabel"> 3. Blur Image in Website</div>
                <div
                  style={{ marginTop: "10px", marginBottom: "20px" }}
                  className="form-check form-switch "
                >
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="is_blur"
                    name="is_blur"
                    checked={formik.values.is_blur}
                    onChange={formik.handleChange}
                  />
                  <span
                    style={{
                      color: "#2B171B",
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                  >
                    {formik.values.is_blur ? "Yes" : "No"}
                  </span>

                  {formik.errors.is_blur && formik.touched.is_blur && (
                    <div className="text-danger">{formik.errors.is_blur}</div>
                  )}
                </div>
              </div>
            </div>
            {/* row 6 */}
            <div className="contact-subcontainer">
              <div style={{ marginTop: "20px" }}>
                <input
                  type="checkbox"
                  id="is_accepted"
                  name="is_accepted"
                  checked={formik.values.is_accepted}
                  onChange={formik.handleChange}
                />
                &nbsp;
                <span className="checkboxLabel">
                  By selecting on checkbox, you agree to the Terms & Conditions
                </span>
                {formik.errors.is_accepted && formik.touched.is_accepted && (
                  <div className="text-danger">{formik.errors.is_accepted}</div>
                )}
              </div>
            </div>
          </div>
          {/* submit Button */}

          <div>
            <div className="btnBasicSave">
              <Button type="submit">Submit</Button>
            </div>

            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              open={open}
              onClose={handleClose}
              closeAfterTransition
            >
              <Fade in={open}>
                <Box sx={style} className="modal-box">
                  <img srcSet={successImg} />
                  <Typography
                    id="transition-modal-title"
                    variant="h6"
                    component="h2"
                  >
                    Thank You
                  </Typography>
                  <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                    The profile has been successfully updated
                  </Typography>
                </Box>
              </Fade>
            </Modal>
          </div>
        </form>
      </div>
    </>
  );
}
